import ModalsList from './ModalsList';

export default ModalsList;
